
import L,{Control} from 'leaflet';
 
 L.Control.MapSidebar = L.Control.extend({
    options: {
        position: 'topleft',
        title: 'Legend'
    },

    initialize: function(innerHTML, options){
        L.Util.setOptions(this, options);
        this._innerHTML = innerHTML;
        this._verticalPosition = this.options.position.indexOf('left') != -1 ? 'left' : 'right';
        this._isTopPosition = this.options.position.indexOf('top')!= -1 ? true : false;
    },

    onAdd: function(map){
        this._container = L.DomUtil.create('div', 'leaflet-control-sidebar leaflet-bar leaflet-control');
        var link = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single', this._container);
        link.title = 'Menu';
        L.DomUtil.create('span', 'menu-bar', link);

        //open on desktop
        var openClass = screen.width > 576 ? 'open' : '';

        this._menu = L.DomUtil.create('div', 'leaflet-sidebar ' + this._verticalPosition + ' ' + openClass , map._container);      
        if(this._isTopPosition){
            this._menu.style.top = '15px';
        }else{
            this._menu.style.bottom = '15px';
        }
        var closeButton = L.DomUtil.create('span', 'leaflet-sidebar-close-button', this._menu);
        closeButton.title = 'Close Menu';
        var floatDirection = this._verticalPosition == 'left' ? 'right' :'left';
        closeButton.style.float = floatDirection;
               
        this._titleBar = L.DomUtil.create('div', 'leaflet-sidebar-titlebar', this._menu);
        this._titleBar.innerHTML = this.options.title;
        this._contents = L.DomUtil.create('div', 'leaflet-sidebar-contents', this._menu);
        this._contents.innerHTML = this._innerHTML;
        this._contents.style.clear = 'both';

        L.DomEvent.disableClickPropagation(this._menu);
        L.DomEvent
            .on(link, 'click', L.DomEvent.stopPropagation)
            .on(link, 'click', function(){
                // Open
                //this._animate(this._menu, frominit, 0, true, ispx, unit);
                L.DomUtil.addClass(this._menu,'open');

            }, this)
            .on(closeButton, 'click', L.DomEvent.stopPropagation)
            .on(closeButton, 'click', function(){
                // Close
                //this._animate(this._menu, 0, frominit, false, ispx, unit);
                L.DomUtil.removeClass(this._menu,'open');
            }, this);
        L.DomEvent.on(this._menu, 'mouseover', function(){
            map.scrollWheelZoom.disable();
        });
        L.DomEvent.on(this._menu, 'mouseout', function(){
            map.scrollWheelZoom.enable();
        });

        if(this.options.hidden){
            this.hide();
        }

        return this._container;
    },

    onRemove: function(map){
        //Remove sliding menu from DOM
        map._container.removeChild(this._menu);
        delete this._menu;
    },

    setContents: function(innerHTML){
        this._innerHTML = innerHTML;
        this._contents.innerHTML = this._innerHTML;
    },

    hide: function () {
        this._container.style.display = 'none';
    },

    show: function () {
        this._container.style.display = 'inherit';
    }
});

L.control.mapSidebar = function(innerHTML, options) {
    return new L.Control.MapSidebar(innerHTML, options);
};

